export const EPARAKSTS_ORIGINAL_URI_COOKIE = 'eparaksts_original_uri';
